import React from 'react';
import { SVGIcon } from '@yme/atoms/svg-icon';
import { VisuallyHidden } from '@yme/utils/styles';
import { LEADING_ICON, TRAILING_ICON } from './constants';
import { LabelStyled, SVGIconCustomStyled, SVGIconCustomWrapperStyled } from './styled';
export function ContentButtonWithIcon({ hasIconButton, iconComponent, label, iconRotate, labelRef = undefined, }) {
    const isIconLeft = hasIconButton === LEADING_ICON;
    const isIconRight = hasIconButton === TRAILING_ICON;
    const orderChildElem = (isIconRight && 3) || (isIconLeft && 1) || 0;
    const isIconLeftOrIsIconRight = isIconLeft || isIconRight;
    if (isIconLeftOrIsIconRight) {
        return (React.createElement(SVGIconCustomWrapperStyled, null,
            React.createElement(SVGIconCustomStyled, { type: iconComponent, order: orderChildElem, iconRotate: iconRotate }),
            React.createElement(LabelStyled, { ...(labelRef && {
                    ref: labelRef,
                }) }, label)));
    }
    // case: if 'hasIconButton === ICON_ONLY'
    return (React.createElement(React.Fragment, null,
        React.createElement(SVGIcon, { type: iconComponent, iconRotate: iconRotate }),
        React.createElement(VisuallyHidden, null, label)));
}
ContentButtonWithIcon.displayName = 'ContentButtonWithIcon_Component';
